import { Helmet } from 'react-helmet-async';
import { toSeoAbsoluteUrl } from '../../utils/seoSiteUrl';

interface WebsiteSchemaProps {
  url: string;
  name: string;
  description: string;
  searchUrl?: string;
}

/**
 * WebsiteSchema component generates JSON-LD structured data for the homepage.
 * Enables search action and better website understanding in search engines.
 */
export default function WebsiteSchema({ 
  url, 
  name, 
  description,
  searchUrl = '/events?search={search_term_string}'
}: WebsiteSchemaProps) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name,
    description,
    url: toSeoAbsoluteUrl(url),
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: toSeoAbsoluteUrl(searchUrl),
      },
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
}
